import script from "./ImagePreviewZoomed.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagePreviewZoomed.vue?vue&type=script&setup=true&lang=js"

import "./ImagePreviewZoomed.vue?vue&type=style&index=0&id=f56cbeac&lang=scss"

const __exports__ = script;

export default __exports__